import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Editorial markdown renderer used by published essays AND the editor preview.
 * One source of truth, so what writers see matches what readers see.
 *
 *   supports: # ## ###  **bold**  *italic*  - bullets  1. lists
 *             > pull quote   ---  horizontal divider   line breaks
 */
export default function MarkdownContent({ children, withDropCap = false, className = "" }) {
  return (
    <div
      data-testid="markdown-content"
      className={`editorial-prose ${withDropCap ? "with-drop-cap" : ""} ${className}`}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          // Open external links in a new tab; keep internal links inline.
          a: ({ node, ...props }) => {
            const isExternal = props.href?.startsWith("http");
            return (
              <a
                {...props}
                target={isExternal ? "_blank" : undefined}
                rel={isExternal ? "noreferrer noopener" : undefined}
              />
            );
          },
        }}
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
